import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

const mainColumnsPaddingBottom = 57;

export const rightColumnCss = css({
  [MediaQueries.xl]: {
    alignItems: 'flex-end',
    paddingBottom: mainColumnsPaddingBottom,
  },
});

export const leftColumnCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'space-between',
  paddingTop: 8,
  paddingBottom: 32,
  [MediaQueries.mdAndUp]: {
    paddingBottom: 48,
  },
  [MediaQueries.xl]: {
    paddingTop: 24,
    paddingBottom: mainColumnsPaddingBottom,
  },
});

export const rowGetInTouchCss = css({
  marginBottom: 200,
  [MediaQueries.md]: {
    marginBottom: 300,
  },
  [MediaQueries.lg]: {
    marginBottom: 100,
  },
  [MediaQueries.xl]: {
    marginBottom: 'calc(30vh - 50px)',
  },
});

export const firstTitleCss = css(typography.effra18, {
  color: colorsPalette.white,
  marginBottom: 8,
  [MediaQueries.lgAndUp]: {
    marginBottom: 4,
  },
});

export const firstDescriptionCss = css(typography.effra34, {
  color: colorsPalette.grey40,
  fontWeight: fontWeights.light,
  marginBottom: 18,
  [MediaQueries.md]: {
    marginBottom: 32,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 28,
  },
});

export const secondTitleCss = css(typography.effra18, {
  color: colorsPalette.white,
  marginBottom: 8,
  [MediaQueries.lgAndUp]: {
    marginBottom: 9,
  },
});

export const secondDescriptionCss = css(typography.effra34, {
  color: colorsPalette.grey40,
  fontWeight: fontWeights.light,
  marginBottom: 32,
  [MediaQueries.mdAndUp]: {
    marginBottom: 36,
  },
});

export const listOfWaysToWorkCss = css({
  width: '100%',
});

export const waysToWorkItemCss = css({
  marginBottom: 19,
  textAlign: 'end',
});

export const waysToWorkTextCss = css(typography.effra34, {
  fontWeight: fontWeights.light,
  pointerEvents: 'none',
  color: colorsPalette.white,
});

export const waysToWorkButtonCss = css({
  cursor: 'pointer',
});

export const phoneNumberCss = css(typography.effra28, {
  display: 'inline-block',
  fontWeight: fontWeights.light,
  [MediaQueries.mdAndUp]: {
    ...typography.effra34,
    fontWeight: fontWeights.light,
  },
  '.phone-container': {
    color: colorsPalette.white,
  },
  '.phone-label': {
    display: 'none',
  },
  '.phone-alternate-icon': {
    fontSize: 17,
    color: colorsPalette.red,
    lineHeight: '42px',
    marginRight: 10,
  },
  '.phone-number': {
    position: 'relative',
    '::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      backgroundColor: colorsPalette.grey90,
      height: 1,
      width: '100%',
    },
  },
});
